import { Badge, Modal, Table } from "flowbite-react";
import {
  formatDateToDDMM,
  formatDateToYY,
  formatToReal,
  getCompanyAge,
  getImageURLScore,
  getLetterScore,
  getScoreLegends,
  isValidCNPJ,
  maskCEP,
  parseFoundationDate,
} from "../../utils/utils";
import TitleStripe from "../common/TitleStripe";
import NoOcurrence from "../common/query/NoOcurrence";
import Protestos from "../common/query/Protestos";
import ChequesSemFundos from "../common/query/ChequesSemFundos";
import ChequesSustados from "../common/query/ChequesSustados";
import PendenciasFinanceiras from "../common/query/PendenciasFinanceiras";
import AcoesCiveis from "../common/query/AcoesCiveis";
import FalenciaRecuperacaoJudicial from "../common/query/FalenciaRecuperacaoJudicial";
import QuadroSocietario from "../common/query/QuadroSocietario";
import HistoricoConsultas from "../common/query/HistoricoConsultas";
import AvisoCard from "../common/query/AvisoCard";
import Score from "../common/query/Score";
import Administrador from "../common/query/Administrador";
import ScoreRating from "./custom-queries-credit/ScoreRating";
import DecisionBanner from "./DecisionBanner";
import moment from "moment";
import StreetView from "../common/query/StreetView";
import { HiOutlineEye } from "react-icons/hi";
import { useState } from "react";
import ModalReceitaFederal from "../modals/ModalReceitaFederal";

const LimiteCreditoQuery = ({ data, dataFull }) => {
  const probRaw = +data?.score?.score_pj?.probabilidade;
  const prob = typeof probRaw === "number" ? probRaw : null;

  return (
    <div>
      <div>
        <TitleStripe>🏦 Limite de crédito</TitleStripe>
        <div className="relative rounded-2xl overflow-hidden bg-white shadow-sm mt-3">
          {/* fundo sutil */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50" />
          <div className="relative p-4">
            <div className="text-xl font-extrabold text-gray-900">
              {data?.score ? formatToReal(data?.score) : "Indisponível"}
            </div>

            {/* linha auxiliar opcional */}
            <div className="mt-1 text-[12px] text-gray-500">
              {data?.score ? (
                <div
                  className="mt-2 text-[11px] text-gray-600 bg-white/60 rounded-lg p-2"
                  style={{ lineHeight: "1.1" }}
                >
                  Limite de crédito estimado a partir de informações
                  comportamentais e cadastrais da empresa.
                </div>
              ) : (
                <div
                  className="mt-2 text-[11px] text-gray-600 bg-white/60 rounded-lg p-2"
                  style={{ lineHeight: "1.1" }}
                >
                  {data?.texto ||
                    " Limite de crédito estimado a partir de informações comportamentais e cadastrais da empresa."}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LimiteCreditoQuery;
